import { Component, DestroyRef, Input, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { contrastOutline, moonOutline, sunnyOutline } from 'ionicons/icons';
import { ThemeService, ThemeMode } from '../../services/theme.service';

interface ThemeOption {
  mode: ThemeMode;
  icon: string;
  title: string;
}

@Component({
  selector: 'app-theme-selector',
  standalone: true,
  imports: [IonIcon],
  templateUrl: './theme-selector.component.html',
  styleUrls: ['./theme-selector.component.scss']
})
export class ThemeSelectorComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly themeService = inject(ThemeService);

  @Input() stretch = false;
  currentTheme: ThemeMode = this.themeService.getCurrentTheme();
  animationsEnabled = false;
  readonly themeOptions: ThemeOption[] = [
    { mode: 'light', icon: 'sunny-outline', title: 'Light mode' },
    { mode: 'system', icon: 'contrast-outline', title: 'System mode' },
    { mode: 'dark', icon: 'moon-outline', title: 'Dark mode' }
  ];

  constructor() {
    addIcons({
      sunnyOutline,
      contrastOutline,
      moonOutline
    });
  }

  ngOnInit(): void {
    this.themeService.currentTheme$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((theme) => {
        this.currentTheme = theme;
      });
  }

  changeTheme(theme: ThemeMode): void {
    this.animationsEnabled = true;
    this.themeService.setTheme(theme);
  }

  get activeIndex(): number {
    const index = this.themeOptions.findIndex((option) => option.mode === this.currentTheme);
    return index >= 0 ? index : 0;
  }
}
